import './style.scss';

import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { useTranslation } from "react-i18next"

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO title="404: Not found" header={ { siteTitle: 'Page not found' } }/>
      <div className="not-found d-flex flex-column justify-content-center align-items-center text-center">
        <div>
          <h1 className="display-1 text-primary mb-3">404</h1>
          <p className="lead fs-4">{t("La pagina che cerchi non è più disponibile")}</p>
          <a className="cta btn btn-lg btn-outline-dark b-light mt-1" href="/">{t("Torna alla homepage")}</a>
        </div>
      </div>
    </Layout>
  )
};

export default NotFoundPage;
